/* Cozy Clouds Empire — small, dependency-free theme behaviours. */
(function () {
  'use strict';

  /* Mobile navigation ---------------------------------------------------- */
  var burger = document.querySelector('[data-cce-burger]');
  var mobnav = document.querySelector('[data-cce-mobnav]');
  if (burger && mobnav) {
    var setNav = function (open) {
      mobnav.setAttribute('data-open', open ? 'true' : 'false');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    burger.addEventListener('click', function () {
      setNav(mobnav.getAttribute('data-open') !== 'true');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobnav.getAttribute('data-open') === 'true') { setNav(false); burger.focus(); }
    });
  }

  /* Copy discount code ---------------------------------------------------- */
  var copyBtn = document.querySelector('[data-cce-copy]');
  if (copyBtn) {
    var copyStatus = document.querySelector('[data-cce-copy-status]');
    copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-cce-copy');
      var done = function () { if (copyStatus) copyStatus.textContent = 'Code ' + code + ' copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    });
  }

  /* Collection sort: submit as soon as the choice changes ------------------ */
  var sortForm = document.querySelector('[data-cce-sort]');
  if (sortForm) {
    sortForm.addEventListener('change', function () { sortForm.submit(); });
  }

  /* Related products: fetch Shopify recommendations once the block is near view */
  var related = document.querySelector('[data-cce-related]');
  if (related && related.hasAttribute('hidden') && related.dataset.url) {
    var loadRelated = function () {
      fetch(related.dataset.url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cce-related]');
        if (fresh && fresh.querySelector('.cce-card')) {
          related.innerHTML = fresh.innerHTML;
          related.removeAttribute('hidden');
        }
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); loadRelated(); }
      }, { rootMargin: '600px 0px' });
      io.observe(related);
    } else { loadRelated(); }
  }

  /* Homepage sticky buy bar ---------------------------------------------- */
  var sticky = document.getElementById('cce-sticky');
  if (sticky) {
    var onScroll = function () { sticky.hidden = window.scrollY < window.innerHeight * 0.6; };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Announcement countdown ------------------------------------------------ */
  var clock = document.getElementById('cce-clock');
  if (clock && clock.dataset.end) {
    var end = new Date(clock.dataset.end + 'T23:59:59');
    if (!isNaN(end)) {
      (function tick() {
        var ms = end - new Date();
        if (ms <= 0) { clock.textContent = ''; return; }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
        clock.textContent = '\u00b7 ends in ' + d + 'd ' + h + 'h ' + m + 'm';
        setTimeout(tick, 30000);
      })();
    }
  }

  /* Product cards: choosing a colour swatch swaps the card's large image to that colour,
     marks the swatch as selected, and points the card's links at that variant, so the image,
     the highlighted swatch and the page the card opens always agree. Modified clicks
     (new tab etc.) and swatches without a photo fall through to normal navigation. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('[data-cce-card-swatch]') : null;
    if (!sw) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    var card = sw.closest('.cce-card');
    var img = card ? card.querySelector('.cce-card__media img') : null;
    if (!card || !img || !sw.dataset.image) return;
    e.preventDefault();
    img.src = sw.dataset.image;
    if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
    img.alt = sw.dataset.alt || '';
    card.querySelectorAll('[data-cce-card-swatch]').forEach(function (other) {
      var on = other === sw;
      other.setAttribute('aria-current', on ? 'true' : 'false');
      other.classList.toggle('is-selected', on);
    });
    var label = card.querySelector('[data-cce-swatch-name]');
    if (label) label.textContent = sw.dataset.name || '';
    var url = sw.dataset.url;
    if (url) {
      card.querySelectorAll('.cce-card__media, .cce-card__title a, .cce-card__cta').forEach(function (a) {
        a.setAttribute('href', url);
      });
    }
  });

  /* Product gallery ------------------------------------------------------- */
  var gallery = document.querySelector('[data-cce-gallery]');
  var galleryMain = gallery ? gallery.querySelector('[data-cce-gallery-main]') : null;

  /* Swap the large image and keep it responsive (rebuilds srcset from the 1200px URL). */
  /* Display the exact requested gallery image. */
var setMain = function (url, alt) {
  if (!galleryMain || !url) return;

  // Clear old responsive candidates before setting the new image.
  // Otherwise the browser can display an old srcset image despite a new src.
  galleryMain.removeAttribute('srcset');
  galleryMain.src = url;
  galleryMain.alt = alt || '';
};

  /* Product "Choose options" bar: scroll to the buy box and focus the first control. */
  document.addEventListener('click', function (e) {
    var jump = e.target.closest ? e.target.closest('[data-cce-jump]') : null;
    if (!jump) return;
    var target = document.querySelector('[data-cce-product-form]');
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var first = target.querySelector('input:not([type="hidden"]), button');
    if (first) { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }
  });

  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-cce-thumb]');
      if (!thumb || !galleryMain) return;
      setMain(thumb.dataset.full, thumb.dataset.alt);
      gallery.querySelectorAll('[data-cce-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------------------------------------------------
     Product variant picker.

     Each product option (Color, Pattern, Size, …) renders its own set of
     controls. Choosing one value keeps every other option where it is,
     resolves the matching variant, and updates the hidden id field the
     product form has always submitted. Nothing here is product-specific:
     it reads whatever options and variants Shopify sends down.
     ---------------------------------------------------------------------- */
  var productForm = document.querySelector('[data-cce-product-form]');
  if (productForm) {
    var picker = productForm.querySelector('[data-cce-variant-picker]');
    var dataEl = document.querySelector('[data-cce-variant-data]');
    var idField = productForm.querySelector('[data-cce-variant-id]');
    var button = productForm.querySelector('[data-cce-add]');
    var priceNow = document.querySelector('[data-cce-price-now]');
    var priceWas = document.querySelector('[data-cce-price-was]');
    var priceSave = document.querySelector('[data-cce-price-save]');
    var barPrice = document.querySelector('[data-cce-bar-price]');
    var variants = [];

    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; }
    }

    if (picker && variants.length) {
      var inputs = function () {
        return Array.prototype.slice.call(picker.querySelectorAll('[data-cce-option-input]'));
      };

      /* Values currently chosen, in option order. */
      var currentValues = function () {
        var values = [];
        inputs().forEach(function (input) {
          if (input.checked) values[Number(input.dataset.optionPosition) - 1] = input.value;
        });
        return values;
      };

      /* First variant whose options match every chosen value. */
      var matchVariant = function (values) {
        for (var i = 0; i < variants.length; i++) {
          var opts = variants[i].options || [];
          var hit = true;
          for (var j = 0; j < values.length; j++) {
            if (values[j] !== undefined && opts[j] !== values[j]) { hit = false; break; }
          }
          if (hit) return variants[i];
        }
        return null;
      };

      /* Strike through combinations that do not exist or are out of stock. */
      var markAvailability = function () {
        var chosen = currentValues();
        inputs().forEach(function (input) {
          var position = Number(input.dataset.optionPosition) - 1;
          var trial = chosen.slice();
          trial[position] = input.value;
          var variant = matchVariant(trial);
          var label = input.closest('.cce-opt');
          var sold = !variant || !variant.available;
          if (label) label.setAttribute('data-unavailable', sold ? 'true' : 'false');
          input.setAttribute('aria-disabled', sold ? 'true' : 'false');
        });
      };

      /* Echo the chosen value next to each option name. */
      var markLabels = function () {
        picker.querySelectorAll('[data-cce-optset]').forEach(function (set) {
          var checked = set.querySelector('[data-cce-option-input]:checked');
          var out = set.querySelector('[data-cce-option-current]');
          if (out && checked) out.textContent = checked.value;
        });
      };

      /* The image carried by whichever swatch is currently chosen. Used when
         the exact size variant has no image assigned in the admin, so every
         size keeps showing the colour the customer picked. */
      var swatchImage = function () {
        var checked = picker.querySelectorAll('[data-cce-option-input][data-swatch-image]:checked');
        for (var i = 0; i < checked.length; i++) {
          if (checked[i].dataset.swatchImage) {
            return {
              image: checked[i].dataset.swatchImage,
              image_id: checked[i].dataset.swatchImageId,
              image_alt: checked[i].dataset.swatchImageAlt
            };
          }
        }
        return null;
      };

      /* The large image is whatever the chosen swatch shows. That is the whole
         point of the swatch, so it wins outright: if the Sage swatch shows a
         particular photo, selecting Sage in any size shows that same photo.
         A variant's own image is only used when the option has no swatch,
         which happens when Shopify has no image for that colour at all. */
      var showVariantImage = function (variant) {
  if (!gallery || !galleryMain) return;

  // Prefer the image assigned to the exact selected variant.
  // Use the chosen swatch's image only when that variant has none.
  var picture = variant && variant.image
    ? {
        image: variant.image,
        image_id: variant.image_id,
        image_alt: variant.image_alt
      }
    : swatchImage();

  if (!picture || !picture.image) return;

  setMain(picture.image, picture.image_alt);
  gallery.querySelectorAll('[data-cce-thumb]').forEach(function (thumb) {
    var match = picture.image_id != null &&
      picture.image_id !== '' &&
      String(thumb.dataset.imageId) === String(picture.image_id);

    thumb.setAttribute('aria-current', match ? 'true' : 'false');
  });
};

      var applyVariant = function (variant) {
        markLabels();
        markAvailability();

        if (!variant) {
          showVariantImage(null);
          if (button) {
            button.disabled = true;
            button.textContent = button.dataset.textUnavailable || 'Unavailable';
          }
          return;
        }

        if (idField) idField.value = variant.id;

        if (priceNow) priceNow.textContent = variant.price_money;
        if (barPrice) barPrice.textContent = variant.price_money;

        if (priceWas) {
          priceWas.textContent = variant.compare_money || '';
          priceWas.hidden = !variant.compare_money;
        }
        if (priceSave) {
          priceSave.textContent = variant.save_money || '';
          priceSave.hidden = !variant.save_money;
        }

        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.textAdd : button.dataset.textSold;
        }

        showVariantImage(variant);

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };

      picker.addEventListener('change', function (e) {
        if (!e.target.matches('[data-cce-option-input]')) return;
        applyVariant(matchVariant(currentValues()));
      });

      /* Set the initial availability state without touching the URL. */
      markLabels();
      markAvailability();
    }
  }
})();
